import { FC } from "react";
import { TeamLogo } from "../../../../Components/TeamLogo";
import { TeamName } from "../../../../Components/TeamName";
import { ResolvedTeamReference } from "../../../../Components/ResolvedTeamReference";
import { components } from "../../../../openapi/generated-types";

interface GamePreviewCardProps {
  game: components["schemas"]["Game"];
}

export const GamePreviewCard: FC<GamePreviewCardProps> = ({ game }) => {
  return (
    <div
      style={{
        backgroundColor: "rgb(30,30,30)",
        color: "white",
        fontSize: 36,
        display: "grid",
        gridTemplateColumns: "4fr 1fr 1fr 1fr 4fr",
        alignItems: "center",
        textAlign: "center",
        gap: "5px",
        padding: "30px 15px",
      }}
    >
      <div
        style={{
          textAlign: "right",
          lineClamp: "1",
          overflow: "hidden",
          textOverflow: "ellipsis",
          minWidth: 0,
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-all",
        }}
      >
        {game.actualTeams.homeTeamId ? (
          <TeamName variant="medium" teamId={game.actualTeams.homeTeamId} />
        ) : (
          <ResolvedTeamReference
            teamReference={game.plannedTeams.home}
            competitionId={game.competitionId}
          />
        )}
      </div>
      <div>
        <div style={{ width: "50px", marginLeft: "auto" }}>
          <TeamLogo height={50} teamId={game.actualTeams.homeTeamId} />
        </div>
      </div>
      <div>{game.result ? `${game.score.home}:${game.score.guest}` : "–"}</div>
      <div>
        <div style={{ width: "50px" }}>
          <TeamLogo height={50} teamId={game.actualTeams.guestTeamId} />
        </div>
      </div>
      <div
        style={{
          textAlign: "left",
          lineClamp: "1",
          overflow: "hidden",
          textOverflow: "ellipsis",
          minWidth: 0,
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-all",
        }}
      >
        {game.actualTeams.guestTeamId ? (
          <TeamName variant="medium" teamId={game.actualTeams.guestTeamId} />
        ) : (
          <ResolvedTeamReference
            teamReference={game.plannedTeams.guest}
            competitionId={game.competitionId}
          />
        )}
      </div>
    </div>
  );
};

export const GamePreviewLabel: FC<{ label: string }> = ({ label }) => {
  return (
    <div
      style={{
        backgroundColor: "rgb(40,40,40)",
        textTransform: "uppercase",
        color: "white",
        fontSize: 18,
        fontWeight: "bold",
        padding: "15px 30px",
      }}
    >
      {label}
    </div>
  );
};

export const GamePreviewPlaceholder: FC<{ message: string }> = ({
  message,
}) => {
  return (
    <div
      style={{
        backgroundColor: "rgb(30,30,30)",
        color: "white",
        textAlign: "left",
        fontSize: 36,
        padding: "30px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ height: "50px", display: "flex", alignItems: "center" }}>
        {message}
      </div>
    </div>
  );
};
